<div class="modal-body bg-transparent">
    <div class="row d-flex justify-content-center">
        <div class="spinner-border text-white p-5" role="status">
            <span class="sr-only">{{ message }}</span>
        </div>
    </div>
    <div class="row d-flex justify-content-center mt-4">
        <h4 class="text-white">{{ message }}</h4>
    </div>
</div>